export default __webpack_public_path__ + "static/media/100_ml_e.0e6cda25.svg";